import { useMemo } from 'react'
import { getBedbankPackageCapacity } from 'lib/offer/bedbankCapacityUtils'
import OfferCardCapacityItems, { OfferCardCapacityGrid } from './OfferCardCapacityItems'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate
}

function BedbankCardCapacity({ offer }: Props) {
  const capacity = useMemo(() => getBedbankPackageCapacity(offer.packages[0]), [offer.packages])

  if (!capacity) return null

  return <OfferCardCapacityGrid data-testid="bedbank-card-capacity">
    <OfferCardCapacityItems guests={capacity.guests} bedrooms={capacity.bedrooms} bathrooms={capacity.bathrooms} />
  </OfferCardCapacityGrid>
}

export default BedbankCardCapacity
